export var waitForSelector = function (selector, cb, cleanupCallback) {
    var element = null;
    var interval = setInterval(function () {
        element = document.querySelector(selector);
        if (element) {
            clearInterval(interval);
            cb(element);
        }
    }, 1000);
    return function () {
        clearInterval(interval);
        cleanupCallback(element);
    };
};
